import {StyleSheet} from "aphrodite";

import {semanticColor} from "@khanacademy/wonder-blocks-tokens";
import {standardTransition} from "@khan/shared-styles";

// Min height of the divs below input form fields. Gives enough space
// for 1 line of error messages or warnings to be shown under each
// input field.
const FIELD_REQ_HEIGHT = 22;

// Field requirement and error text on input fields have this line height.
const FIELD_REQ_LINE_HEIGHT = 18;

export default StyleSheet.create({
    fieldError: {
        color: semanticColor.core.foreground.critical.subtle,
        lineHeight: `${FIELD_REQ_HEIGHT}px`,
        // We don't anticipate even the longest field error string to exceed
        // 4 lines (even at 320px wide screen sizes). Setting a max-height
        // allows us to have smooth height transitions, which is currently
        // (Sept 2017) not possible with setting a min-height.
        maxHeight: `calc(4 * ${FIELD_REQ_LINE_HEIGHT}px)`,
        transition: standardTransition,
        transitionProperty: `max-height, opacity`,
    },
});
